@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if (getTenant($.row[$.adata.fetch_key]); as tenant) {
    <span>{{
      tenant.name_primary_language || tenant.name_secondary_language
    }}</span>
  }
}
